




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable_footer,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable_rows,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders,
} from '@/queries/__generated__/paychecksAndBookkeepingReconciliationReport';

@Component({})
export default class BookkeptTable extends Vue {
  @Prop({ required: true }) private headers!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders[];
  @Prop({ required: true }) private rows!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable_rows[];
  @Prop({ required: true }) private footer!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable_footer[];
}
